import { useState } from 'react'

const capitalize = (s) => s ? s.charAt(0).toUpperCase() + s.slice(1) : ''

const getImageSrc = (item) => {
  const k = item.item_key
  switch (item.category) {
    case 'character':  return `/assets/avatar/characters/${capitalize(k)}.png`
    case 'skin':       return `/assets/avatar/clothes/${k}/${k}-thumb.png`
    case 'hat':        return `/assets/avatar/hats/${k}-thumb.png`
    case 'hand_item':  return `/assets/avatar/hand-items/${k}-thumb.png`
    case 'background': return `/assets/avatar/backgrounds/${k}.svg`
    default:           return ''
  }
}

const ShopItemCard = ({ item, isOwned, isEquipped, isInCart, onClick }) => {
  const [imgError, setImgError] = useState(false)

  const isActive = isEquipped || isInCart

  return (
    <div
      onClick={() => onClick(item)}
      style={{
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 4,
        position: 'relative',
        transition: 'transform .2s',
        width: '100%',
        boxSizing: 'border-box',
        minWidth: 0,
      }}
      onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-3px)' }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)' }}
    >
      {/* 체크마크 (장착/카트) */}
      {isEquipped && (
        <div style={{
          position: 'absolute', top: 4, right: 4, width: 24, height: 24, borderRadius: '50%',
          background: '#4F6BED', display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 13, color: '#fff', fontWeight: 700, zIndex: 2,
          boxShadow: '0 2px 6px rgba(79,107,237,.4)',
        }}>
          ✓
        </div>
      )}
      {isInCart && !isOwned && !isEquipped && (
        <div style={{
          position: 'absolute', top: 4, right: 4, width: 24, height: 24, borderRadius: '50%',
          background: '#F59E0B', display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 11, color: '#fff', fontWeight: 700, zIndex: 2,
          boxShadow: '0 2px 6px rgba(245,158,11,.4)',
        }}>
          🛒
        </div>
      )}

      {/* 썸네일 배경 박스 */}
      <div style={{
        width: '100%',
        aspectRatio: item.category === 'background' ? '4/3' : '1',
        borderRadius: 16,
        overflow: 'hidden',
        background: '#F0F4FA',
        border: isActive ? '2.5px solid #4F6BED' : '2.5px solid transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxSizing: 'border-box',
        transition: 'border-color .15s',
      }}>
        {!imgError ? (
          <img
            src={getImageSrc(item)}
            alt={item.item_name}
            onError={() => setImgError(true)}
            style={{
              width: item.category === 'background' ? '100%' : '80%',
              height: item.category === 'background' ? '100%' : '80%',
              objectFit: item.category === 'background' ? 'cover' : 'contain',
            }}
          />
        ) : (
          <img src={CATEGORY_EMOJI[item.category]} alt={item.category} style={{ width: 36, height: 36, objectFit: 'contain' }} />
        )}
      </div>

      {/* 아이템명 */}
      <p style={{
        margin: 0, fontSize: 12, fontWeight: 700, color: '#1A2B4A',
        textAlign: 'center', lineHeight: 1.3, maxWidth: '100%',
        minHeight: 16,
        wordBreak: 'keep-all',
      }}>
        {item.item_name}
      </p>

      {/* 가격 or 상태 */}
      {isEquipped ? (
        <span style={{ fontSize: 11, fontWeight: 800, color: '#4F6BED' }}>Equipped</span>
      ) : isOwned ? (
        <span style={{ fontSize: 11, fontWeight: 700, color: '#93AEFF' }}>Owned</span>
      ) : item.category === 'skin' ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <img src="/assets/icons/gem.png" alt="gem" style={{ width: 13, height: 13, objectFit: 'contain' }} />
          <span style={{ fontSize: 12, fontWeight: 800, color: '#9B59B6' }}>{item.price_gem}</span>
        </div>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <img src="/assets/icons/coin.png" alt="coin" style={{ width: 13, height: 13, objectFit: 'contain' }} />
          <span style={{ fontSize: 12, fontWeight: 800, color: '#F59E0B' }}>{item.price_coin}</span>
        </div>
      )}
    </div>
  )
}

const CATEGORY_EMOJI = {
  character:  '/assets/icons/category-character.png',
  skin:       '/assets/icons/category-skin.png',
  hat:        '/assets/icons/category-hat.png',
  hand_item:  '/assets/icons/pencil.png',
  background: '/assets/icons/category-background.png',
}

export default ShopItemCard
